<template>
  <div ref="promotion" class="promotion notranslate"
    :class="promotion.type"
    :style="promotionStyle">
    <span v-if="promotion.type === 'text'">{{ promotion.text.value }}</span>
    <img v-else :src="promotion.image.value" alt="" />
  </div>
</template>

<script>
export default {
  name: 'ShopItemPromotion',
  props: [
    'locale',
    'promotion',
    'thumbWidth'
  ],
  computed: {
    promotionStyle () {
      const promotionType = this.promotion.type
      const promotionSize = promotionType === 'image' && (Number(this.promotion.image.size) / this.imageBase) * (this.thumbWidth || 285)
      const fontSize = promotionType === 'text' && Math.max(Number((this.promotion.text.fontSize.replace('px', '')) / this.imageBase) * (this.thumbWidth || 285), 10)
      return promotionType === 'text'
      ? {
        fontSize: `${fontSize}px`,
        color: this.promotion.text.textColor,
        backgroundColor: this.promotion.text.backgroundColor
      } : {
        maxWidth: `${promotionSize}px`
      }
    }
  },
  data () {
    return {
      imageBase: 300 // 에디터에서 프로모션 사이즈를 설정할 때의 기준이 된 썸네일 크기
    }
  }
}
</script>
